const html = require('choo/html')

const drag = require('./store/drag.js')
const recording = require('./store/recording.js')
const load = require('./store/load.js')
const sound = require('./store/sound.js')
const ui = require('./store/ui.js')
const tutorial = require('./store/tutorial.js')
const importExport = require('./store/importExport.js')
const theme = require('./store/theme.js')
const { isMobile, isiPad, isSafari } = require('./store/utility/featureDetection.js')

function store(state, emitter) {
  const mobile = isMobile()
  const ipad = isiPad()
  const safari = isSafari()

  state.isMobile = mobile || ipad || safari

  theme(state, emitter)
  load(state, emitter)
  drag(state, emitter)
  recording(state, emitter)
  sound(state, emitter)
  ui(state, emitter)
  tutorial(state, emitter)
  importExport(state, emitter)

}

module.exports = store
